import { combineEpics } from "redux-observable";
import { epicTraderEventBuyPackage } from "./epicTraderEventBuyPackage";
import { epicTraderEventInfo } from "./epicTraderEventInfo";
import { epicTraderEventsBuyPackageRequest } from "./epicTraderEventsBuyPackageRequest";
export var epicTraderEvents = combineEpics(epicTraderEventBuyPackage, epicTraderEventInfo, epicTraderEventsBuyPackageRequest);



//////////////////
// WEBPACK FOOTER
// ./src/features/trader-event/epics/epicTraderEvents.ts
// module id = 2455
// module chunks = 3